import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}garmin/`;

export function checkConnectionStatus() {
    return fetch(`${baseUrl}connectionauthorised`, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getRequestToken() {
    var url = `${baseUrl}getrequesttoken`;

    return fetch(url, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getAccessToken(requestToken, verifier) {
    var url = `${baseUrl}getaccesstoken`;
    var request = { requestToken: requestToken, verifier: verifier}

    return fetch(url, { method: "POST", body: JSON.stringify(request), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function disconnect() {
    return fetch(`${baseUrl}disconnect`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function sendToDevice(routeId) {
    return fetch(`${baseUrl}sendroutetodevice/${routeId}`, { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}




// WEBPACK FOOTER //
// ./src/api/garminApi.js